<template>
  <div class="tw-w-full tw-flex tw-flex-col tw-gap-3 tw-max-w-sm">
    <div class="tw-flex tw-items-center tw-gap-2 ">
      <ValuesSearchSelect
        placeholder="Search for values"
        :is-active="isActive"
        :value-sets="filteredValueSets"
        @select="addValue"
        @search="filterValueSets"
      />
    </div>
    <SelectedValues
      :values="selectedValues"
      @removeValue="removeValue"
    />
  </div>
</template>


<script>
import ValuesSearchSelect from './ValuesSearchSelect.vue';
import SelectedValues from './SelectedValues.vue';

export default {
  name: 'ValuesSelectWrapper',
  components: { ValuesSearchSelect, SelectedValues },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    selectedValues: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      filteredValueSets: [],
      allValueSets: [], // Add this to store all value sets
    };
  },
  created() {
    this.getValueSets();
  },
  methods: {
    async getValueSets() {
      try {
        const res = await fetch('/api/v1/screen_sets/');
        const data = await res.json();
        this.allValueSets = data.screen_sets;
        this.filteredValueSets = this.allValueSets;
      } catch (error) {
        console.error('Error fetching value sets:', error);
      }
    },
    addValue(value) {
      if (!this.selectedValues.find(v => v.id === value.id)) {
        const updatedValues = [...this.selectedValues, value];
        this.$emit('update:selectedValues', updatedValues);
      }
    },
    removeValue(valueId) {
      const updatedValues = this.selectedValues.filter(v => v.id !== valueId);
      this.$emit('update:selectedValues', updatedValues);
    },
    filterValueSets(query) {
      if (!query) {
        this.filteredValueSets = this.allValueSets;
        return;
      }

      const lowercaseQuery = query.toLowerCase();
      this.filteredValueSets = this.allValueSets.filter(valueSet => {
        return valueSet.name.toLowerCase().includes(lowercaseQuery);
      });
    },
  },
};
</script>


<style scoped>

</style>
